import {
  UPLOAD_RECEIPT_FILE_REQUEST,
  UPLOAD_RECEIPT_FILE_SUCCESS,
  UPLOAD_RECEIPT_FILE_ERROR,
  RESET_UPLOAD_RECEIPT_FILE,
} from "../actions/action-type";

const initialState = {
  uploadReceiptFileResponse: {},
  isUploadReceiptFileError: false,
  isUploadReceiptFileSuccess: false,
  isUploadReceiptFileLoading: false,
  errorDetails: {},
};

const uploadReceiptFileReducer = (state = initialState, { type, uploadReceiptFileResponse, errorDetails }) => {
  switch (type) {
    case UPLOAD_RECEIPT_FILE_REQUEST:
      return {
        ...state,
        isUploadReceiptFileLoading: true,
        isUploadReceiptFileError: false,
        isUploadReceiptFileSuccess: false,
      };
    case UPLOAD_RECEIPT_FILE_SUCCESS:
      return {
        ...state,
        uploadReceiptFileResponse,
        isUploadReceiptFileLoading: false,
        isUploadReceiptFileError: false,
        isUploadReceiptFileSuccess: true,
        errorDetails: {},
      };
    case UPLOAD_RECEIPT_FILE_ERROR:
      return {
        ...state,
        uploadReceiptFileResponse: errorDetails,
        isUploadReceiptFileLoading: false,
        isUploadReceiptFileError: true,
        isUploadReceiptFileSuccess: false,
        errorDetails,
      };
    case RESET_UPLOAD_RECEIPT_FILE:
      return initialState;
    default:
      return state;
  }
};

export default uploadReceiptFileReducer;
